<div *ngIf="waitOnInit" class="d-flex app-text-success justify-content-center align-items-center py-4">
  <span class="spinner-border spinner-border-sm mr-2"></span>
  Loading Users...
</div>

<div *ngIf="!waitOnInit">

  <!-- Lead selector -->
  <div class="form-group mb-4">
    <label class="font-weight-bold">Team Lead</label>
    <select class="form-control" (change)="onLeadChange($event)">
      <option value="">-- Select a Lead --</option>
      <option *ngFor="let user of selectedMembers" [value]="user?.id" [selected]="selectedLead?.id === user?.id">
        {{ userLabel(user) }}
      </option>
    </select>
    <small class="form-text text-muted">Drag users to Team Members first, then select a lead.</small>
  </div>

  <!-- Drag-drop columns -->
  <div class="d-flex drag-drop-container">

    <!-- Available users -->
    <div class="drag-column">
      <h6 class="font-weight-bold mb-2">
        Available Users
        <span class="badge badge-secondary ml-1">{{ filteredAvailableUsers.length }}</span>
      </h6>
      <div class="input-group mb-2">
        <input
          class="form-control form-control-sm"
          type="text"
          placeholder="Filter by name..."
          [(ngModel)]="availableFilter"
        />
        <div class="input-group-append" *ngIf="availableFilter">
          <button class="btn btn-sm app-btn-neutral" type="button" (click)="availableFilter = ''">
            &#x2715;
          </button>
        </div>
      </div>
      <div
        cdkDropList
        #availableList="cdkDropList"
        [cdkDropListData]="availableUsers"
        [cdkDropListConnectedTo]="[selectedList]"
        class="drop-zone"
        (cdkDropListDropped)="onDrop($event)"
      >
        <div *ngFor="let user of filteredAvailableUsers" cdkDrag class="drag-card mb-2">
          <app-user-card [user]="user" [accordion]="false"></app-user-card>
        </div>
        <div *ngIf="availableUsers.length === 0" class="drop-placeholder text-muted text-center py-3">
          No available users
        </div>
      </div>
    </div>

    <!-- Arrow -->
    <div class="drag-arrow d-flex align-items-center justify-content-center">
      &#8644;
    </div>

    <!-- Selected members -->
    <div class="drag-column">
      <h6 class="font-weight-bold mb-2">
        Team Members
        <span class="badge badge-secondary ml-1">{{ selectedMembers.length }}</span>
      </h6>
      <div
        cdkDropList
        #selectedList="cdkDropList"
        [cdkDropListData]="selectedMembers"
        [cdkDropListConnectedTo]="[availableList]"
        class="drop-zone"
        (cdkDropListDropped)="onDrop($event)"
      >
        <div *ngFor="let user of selectedMembers" cdkDrag class="drag-card mb-2">
          <app-user-card [user]="user" [accordion]="false"></app-user-card>
        </div>
        <div *ngIf="selectedMembers.length === 0" class="drop-placeholder text-muted text-center py-3">
          Drag users here
        </div>
      </div>
    </div>

  </div>

  <!-- Submit -->
  <div class="d-flex justify-content-end mt-4">
    <button
      class="btn app-btn-success"
      type="button"
      (click)="onSubmit()"
      [disabled]="waitOnAction || !selectedLead || selectedMembers.length === 0"
    >
      <span *ngIf="waitOnAction" class="spinner-border spinner-border-sm mr-1"></span>
      {{ editTarget ? 'Save Changes' : 'Create Team' }}
    </button>
  </div>

</div>
